/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/057-qrcode': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 1H1v4h4V1zm1-1v6H0V0h6zM2 2h2v2H2zm13-1h-4v4h4V1zm1-1v6h-6V0h6zm-4 2h2v2h-2zm-7 9H1v4h4v-4zm1-1v6H0v-6h6zm-4 2h2v2H2zM7 0h1v1H7zm1 1h1v1H8zM7 2h1v1H7zm1 1h1v1H8zM7 4h1v1H7zm1 1h1v1H8zM7 6h1v1H7zm0 2h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm7-7h1v1h-1zM1 8h1v1H1zm1-1h1v1H2zM0 7h1v1H0zm4 0h1v1H4zm1 1h1v1H5zm1-1h1v1H6zm3 1h1v1H9zm1-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-6 0h1v1H9zm1-1h1v1h-1zm1 1h1v1h-1zm2 0h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-6 0h1v1H9zm1-1h1v1h-1zm2 0h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-5-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 1h1v1h-1zm-3 1h1v1h-1zm2 0h1v1h-1zm2 0h1v1h-1z"/>'
  }
})
